import React from 'react';

interface Props {
  value: number;
  min: number;
  minAverage: number;
  maxAverage: number;
  max: number;
}

// Posición 0-100 % sobre una barra fija en 3 zonas (25 / 50 / 25 %): bajo, promedio y alto.
// Misma lógica que `PriceRangeBar` del sitio público (web Next): dentro de cada zona se
// interpola entre sus límites reales.
const computePosition = (
  value: number,
  min: number,
  minAverage: number,
  maxAverage: number,
  max: number,
) => {
  if (value <= min) return 0;
  if (value >= max) return 100;
  if (value < minAverage) return ((value - min) / (minAverage - min)) * 25;
  if (value <= maxAverage) return 25 + ((value - minAverage) / (maxAverage - minAverage)) * 50;
  return 75 + ((value - maxAverage) / (max - maxAverage)) * 25;
};

const SEGMENT_HEIGHT = 8;
const labelStyle = (color: string): React.CSSProperties => ({ color, fontSize: 10 });

const EstimateRangeBar: React.FC<Props> = ({ value, min, minAverage, maxAverage, max }) => {
  const position = computePosition(value, min, minAverage, maxAverage, max);
  const segment = (background: string): React.CSSProperties => ({
    borderRadius: 999,
    background,
  });

  return (
    <div>
      <div style={{ position: 'relative' }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 2fr 1fr',
            gap: 8,
            height: SEGMENT_HEIGHT,
          }}
        >
          <div style={segment('linear-gradient(to right, #10b981, #2dd4bf)')} />
          <div style={segment('linear-gradient(to right, #22d3ee, #3b82f6, #8b5cf6)')} />
          <div style={segment('linear-gradient(to right, #fb7185, #FA712D)')} />
        </div>
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: `${position}%`,
            width: 14,
            height: 14,
            transform: 'translate(-50%, -50%)',
            borderRadius: '50%',
            border: '4px solid #fff',
            boxSizing: 'border-box',
          }}
        />
      </div>
      <div className="d-flex justify-content-between mt-1">
        <span style={labelStyle('#10b981')}>Más bajo</span>
        <span style={labelStyle('#3b82f6')}>Promedio</span>
        <span style={labelStyle('#FA712D')}>Más alto</span>
      </div>
    </div>
  );
};

export default EstimateRangeBar;
